const state = {
  lineUsers: [],
  listUnreadMessage: [],
  listUnreadByUser: [],
  lastUserMessage: null,
  listNewUserMessage: [],
  total: 0,
  from: 1,
  to: 100,
  listMessages: []
}

const getters = {
  // begin staff
  lineUsers (state) {
    return state.lineUsers
  },
  currentPage (state) {
    return state.currentPage
  },
  lastPage (state) {
    return state.lastPage
  },
  nextPage (state) {
    return state.nextPage
  },
  prevPage (state) {
    return state.prevPage
  },
  total (state) {
    return state.total
  },
  from (state) {
    return state.from
  },
  to (state) {
    return state.to
  },
  // end staff

  // begin message
  listMessages (state) {
    return state.listMessages
  },
  listUnreadMessage (state) {
    return state.listUnreadMessage
  },
  listUnreadByUser (state) {
    return state.listUnreadByUser
  },
  lastUserMessage (state) {
    return state.lastUserMessage
  },
  listNewUserMessage (state) {
    return state.listNewUserMessage
  }
  // end message
}

const mutations = {
  SET_LINE_USERS (state, lineUsers) {
    state.lineUsers = lineUsers
  },
  SET_CURRENT_PAGE (state, currentPage) {
    state.currentPage = currentPage
  },
  SET_LAST_PAGE (state, lastPage) {
    state.lastPage = lastPage
  },
  SET_NEXT_PAGE (state, nextPage) {
    state.nextPage = nextPage
  },
  SET_PREV_PAGE (state, prevPage) {
    state.prevPage = prevPage
  },
  SET_TOTAL (state, total) {
    state.total = total
  },
  SET_FROM (state, from) {
    state.from = from
  },
  SET_TO (state, to) {
    state.to = to
  },
  SET_LIST_MESSAGES (state, listMessages) {
    state.listMessages = listMessages
  },
  RESET_LINE_MESSAGE(state) {
    state.lineUsers = []
    state.listUnreadMessage = []
    state.listUnreadByUser = []
    state.lastUserMessage = null
    state.listNewUserMessage = []
    state.total = 0
    state.from = 1
    state.to = 100
    state.listMessages = []
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
